import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, Version } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { AngularFireModule } from 'angularfire2';
import firebase from 'Firebase';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Camera } from '@ionic-native/camera';
import { DocumentViewer } from '@ionic-native/document-viewer';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { IonicStorageModule } from '@ionic/storage';
import { AppVersion } from '@ionic-native/app-version';
import { Market } from '@ionic-native/market';
import { Push } from '@ionic-native/push';
import { HttpModule } from '@angular/http';
import { DataProvider } from '../providers/data/data';
import { HttpClientModule } from '@angular/common/http';
import { MyApp } from './app.component';


export const firebaseConfig = {
  apiKey: "AIzaSyBgsb1OU-Q_k2n1OvpShVBx9aZd7htgjJw",
  authDomain: "safety-management-e6a6b.firebaseapp.com",
  databaseURL: "https://safety-management-e6a6b-default-rtdb.firebaseio.com",
  projectId: "safety-management-e6a6b",
  storageBucket: "safety-management-e6a6b.appspot.com",
  messagingSenderId: "767998279867",
  appId: "1:767998279867:web:5f0a01f710df944fb6a99e"
};
firebase.initializeApp(firebaseConfig);



@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    ChartsModule,
    IonicModule.forRoot(MyApp),
    HttpModule,
    IonicStorageModule.forRoot(),
  ],

  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],

  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    FileOpener,
    FileTransfer,
    FileTransferObject,
    File,
    Camera,
    DocumentViewer,
    InAppBrowser,
    AppVersion,
    Market,
    Push,
    StatusBar,
    DataProvider,
  ],
  exports: [
    // KaizenKpiPage
  ],

})
export class AppModule { }




// WEBPACK FOOTER //
// ./src/app/app.module.ts